// Angular and RJX Imports
// =========================================================
import { Injectable } from '@angular/core'
// AWS Imports
// =========================================================
import { generateClient } from 'aws-amplify/api'
import { type GraphQLSubscription } from 'aws-amplify/api'

// Prime NG Imports
// =========================================================
import { DialogService } from 'primeng/dynamicdialog'
// Axios Imports
// =========================================================
import axios from 'axios'
// Custom Imports
// =========================================================
import { ToastAlertComponent } from 'src/app/03_shared-components/01_alerts/toast-alert/toast-alert.component'
import { ExecuteGetAPI, ExecutePostAPI, ExecuteDeleteAPI } from './execute_api-calls'
import { type ResponseSubscription } from '../../../API'
import * as subscriptions from '../../../graphql/subscriptions'
import { FormatKey } from 'src/app/utils/global_functions'
import { TriggerApiCallsService } from '../services/cancel-api-call'

@Injectable()
export class ManagementJobsAPIs {
  private readonly client = generateClient()
  clearApiCalls: boolean = false

  constructor (
    public dialogService: DialogService,
    public toastAlert: ToastAlertComponent,
    public triggerApiCallsService: TriggerApiCallsService
  ) {
    // ApiCall Service
    this.triggerApiCallsService.triggerApiCalls$.subscribe({
      next: data => {
        this.clearApiCalls = data['clear_api_calls']
      }
    })
  }

  // Get All Jobs
  async GetAllJobs () {
    // the api call path with the parameter string is needed
    const path = '/jobs/properties'
    const messages = {
      success: '---> API Call Successful: Retrieved All Jobs',
      error: 'Error retrieving rowData for the Size Distro Execution - Job Management Grid.'
    }

    const response = await ExecuteGetAPI(path, this, messages)
    if (response && response.is_success) {
      return await axios
        .get(response.data, {})
        .then(res => {
          console.log('res: ', res)
          return res.data
        })
        .catch(error => {
          console.error('Error retrieving job management grid data: ', error)
          this.toastAlert.showError('Error Loading Data')
          throw error
        })
    } else {
      return []
    }
  }

  // Run Jobs
  async RunJobs (data: string[], queue = true) {
    // the api call path with the parameter string is needed
    const path = '/jobs/qip'
    const totalNumOfData = data.length
    const suffix = totalNumOfData > 1 ? 's' : ''
    const messages = {
      success: `Successfully ran ${totalNumOfData} size distro job${suffix}.`,
      error: `Error running ${totalNumOfData} size distro job${suffix}.`,
      showSuccessToast: true
    }

    return await ExecutePostAPI(path, this, { job_names: data, queue }, messages)
  }

  // Delete jobs
  async DeleteJobs (jobs: string[]) {
    // the api call path with the parameter string is needed
    const path = '/jobs'
    const totalNumOfJobs = jobs.length
    const suffix = totalNumOfJobs > 1 ? 's' : ''
    const messages = {
      success: `Successfully deleted ${totalNumOfJobs} size distro job${suffix}.`,
      error: `Error deleting ${totalNumOfJobs} size distro job${suffix}.`,
      showSuccessToast: true
    }

    return await ExecuteDeleteAPI(path, this, messages, { jobs })
  }

  async JobGridDataSubscription (gridApi): Promise<any> {
    console.log('inside JobGridDataSubscription')
    // console.log("inside jobsToSubscribeTo", jobsToSubscribeTo)
    return this.client
      .graphql<GraphQLSubscription<ResponseSubscription>>({
      query: subscriptions.response
    })
      .subscribe({
        next: ({ data }) => {
          console.log('inside subscriber next', data)

          console.log('inside job_name', data?.response?.job_name)
          console.log('inside status', data?.response?.status)
          console.log('error_message', data?.response?.error_message)
          console.log('finished_at', data?.response?.finished_at)

          if (gridApi && !gridApi['destroyCalled']) {
            const rowData = gridApi.getRowNode(FormatKey(data?.response?.job_name))
            if (rowData) {
              gridApi.applyTransactionAsync({
                update: [
                  {
                    ...rowData.data,
                    status: data?.response?.status,
                    error_message: data?.response?.error_message,
                    finished_at: data?.response?.finished_at
                  }
                ]
              })
            }
          }
        },
        error: error => console.warn(error)
      })
  }
}
